import { Dropdown, Space } from "antd";
import React from "react";
import { FaBars } from "react-icons/fa";
import { IoIosNotifications } from "react-icons/io";
import { Link } from "react-router-dom";
import User from "../../assets/img/user.png";
import logo_d from "../../assets/svg/logo_d.svg";
import logo_w from "../../assets/svg/logo_w.svg";
import Search from "../search/Search";
import ThemeToggle from "../ThemeToggle";

function Navbar({ toggleSidebar }) {
  const items = [
    {
      key: "1",
      label: <Link to="/my-account">My Account</Link>,
    },
    {
      key: "2",
      label: <Link to="/pricing">Pricing</Link>,
    },
    {
      key: "3",
      label: <Link to="/sign_in">Log Out</Link>,
    },
  ];

  return (
    <>
      <div className="left_area">
        <img src={logo_w} className="logo logo-white" alt="" />
        <img src={logo_d} className="logo logo-dark" alt="" />
        <Search />
      </div>
      <div className="right_area">
        <ThemeToggle />
        <IoIosNotifications className="notifi-icon" />
        <Dropdown menu={{ items }}>
          <Link onClick={(e) => e.preventDefault()}>
            <Space className="header_dropdown">
              <div className="title">
                <img src={User} alt="User_Img" />
                <div className="mobile_hide">
                  <p>KvaraX7</p>
                  <span>Admin</span>
                </div>
              </div>
            </Space>
          </Link>
        </Dropdown>
        <div className="toggle_btn" onClick={toggleSidebar}>
          <FaBars className="icons" />
        </div>
      </div>
    </>
  );
}

export default Navbar;
